import "./CRARamittanceDataGridStyle.css";

import {
	EnhancedButtonPrimeReactSeverity,
	RequestParams,
} from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatAmountCommaSeperator, formatDate, formatDateToShow, formatThousandSeperatorWithTwoFixedAmount } from "../../../common/Common";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useTheme } from "@mui/material";

export interface ICRARamittanceDataGridWithManagedBySimplePay {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	isLoading?: any;
	tableMargin?: string;
	footer?: any;
	whiteSpace?: string;
	tableScrollHeight?: boolean;
}

export const CRARamittanceDataGridWithManagedBySimplePay: React.FC<
	ICRARamittanceDataGridWithManagedBySimplePay
> = ({
	rows,
	columns,
	showIndexColumn,
	isLoading,
	tableMargin,
	footer,
	whiteSpace,
	tableScrollHeight,
}) => {
		const columnsBodyWithManagedBySimplePay = (
			rowData: any,
			row: any,
			x: any
		) => {
			if (x.field === "totalRemitted") {
				return (
					<span>
						{rowData[x.field] !== null
							? `$ ${rowData[x.field]
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
							: rowData[x.field]}
					</span>
				);
			}
			if (x.field === "shortExcess" || x.field === "balance") {
				if (rowData[x.field] < 0) {
					return (
						<span style={{ color: "red" }}>
							{rowData[x.field] !== null
								? `$ ${rowData[x.field]
									.toFixed(2)
									.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
								: rowData[x.field]}
						</span>
					);
				} else {
					return (
						<span>
							{rowData[x.field] !== null
								? `$ ${rowData[x.field]
									.toFixed(2)
									.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
								: rowData[x.field]}
						</span>
					);
				}
			}
			if (x.field === "chequeDate") {
				return formatDateToShow(rowData[x.field]);
			}
			if (x.field === "penaltyPercentage") {
				if (rowData[x.field] && rowData[x.field] !== null) {
					return <span>{rowData[x.field]}%</span>;
				} else {
					return <span>{rowData[x.field]}</span>;
				}
			}

			if (
				x.field === "period" ||
				x.field === "dueDate" ||
				x.field === "remitDate" ||
				x.field === "status" ||
				x.field === "emp" ||
				x.field === "chequeNo"
			) {
				return <span>{rowData[x.field]}</span>;
			}
			if (
				x.field === "adj" ||
				x.field === "remitAmount" ||
				x.field === "penaltyPaid"
			) {
				return (
					<span>
						{rowData[x.field] && rowData[x.field] !== null
							? rowData[x.field].toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							: rowData[x.field]}
					</span>
				);
			}
			// if (
			// 	x.field === "dueAmount" ||
			// 	x.field === "craCredit" ||
			// 	x.field === "dueDoller" ||
			// 	x.field === "penaltyCalculated"
			// ) {
			// 	return (
			// 		<span>
			// 			{rowData[x.field] && rowData[x.field] !== null
			// 				? `$ ${rowData[x.field]
			// 					.toFixed(2)
			// 					.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
			// 				: rowData[x.field]}
			// 		</span>
			// 	);
			// }
			if (
				x.field === "dueAmount" ||
				x.field === "craCredit" ||
				x.field === "dueDoller" ||
				x.field === "penaltyCalculated"
			) {
				return (
					<span>
						{rowData[x.field] !== null && rowData[x.field] !== undefined
							? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
							: rowData[x.field]}
					</span>
				);
			}
			return <span>{rowData[x.field]}</span>;  // add to show default data 
		};



		const printPD7Body = (params: any) => {

			return (
				<>
					{params.remitAmount !== null ? (
						<div
							style={{
								display: "flex",
								height: "35px",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<p
								style={{ color: "#0091b3", cursor: "pointer" }}
								onClick={() => alert("Generic Clicked")}
							>
								Generic
							</p>
							&nbsp;<p>/</p>&nbsp;
							<p
								style={{ color: "#0091b3", cursor: "pointer" }}
								onClick={() => alert("Post Clicked")}
							>
								Post
							</p>
							&nbsp;<p>/</p>&nbsp;
							<p
								style={{ color: "#0091b3", cursor: "pointer" }}
								onClick={() => alert("Cheque Clicked")}
							>
								Cheque
							</p>
						</div>
					) : (
						<div
							style={{
								display: "flex",
								height: "35px",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<p
								style={{ color: "#0091b3", cursor: "pointer" }}
								onClick={() => alert("Generic Clicked")}
							>
								Generic
							</p>
						</div>
					)}
				</>
			);
		};

		const shortExcessColumnFooter = (value: number) => {
			if (value < 0) {
				return (
					<>
						Bal: <span style={{ color: "red" }}>
							{formatThousandSeperatorWithTwoFixedAmount(value)}
						</span></>
				);
			} else {
				return (
					<span>
						Bal: {formatThousandSeperatorWithTwoFixedAmount(value)}
					</span>
				);
			}
		};

		return (
			<>
				<DataTable
					value={Array.isArray(rows) ? rows : []}
					responsiveLayout="scroll"
					showGridlines
					resizableColumns
					columnResizeMode="expand"
					scrollable
					scrollHeight={tableScrollHeight ? "75vh" : ""}
					// reorderableColumns
					loading={isLoading}
					footer={footer ? footer : undefined}
					emptyMessage="No Record found."
					className="CRADataGrid"
					style={{
						margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
					}}
					sortMode="single"
				>
					{rows && rows.length ? (
						<Column
							header="#"
							className="indexColumn"
							headerClassName="indexColumn"
							headerStyle={{ width: "24px" }}
							frozen
							hidden={!showIndexColumn}
							body={(data, options) => options.rowIndex + 1}
						></Column>
					) : undefined}
					{columns &&
						columns
							.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
							.map((x: any, index: any) => {
								return (
									<Column
										key={index}
										field={x.field}
										header={x.headerName}
										headerTooltip={x.description}
										headerTooltipOptions={{ position: "top" }}
										hidden={x.hide}
										// sortable={x.sortable}
										reorderable={false}
										dataType={x.type}
										align={x.align}
										alignHeader={x.headerAlign}
										exportable={x.disableExport}
										frozen={x.frozenColumn}
										alignFrozen={x.alignFrozen}
										columnKey={x.field}
										style={{
											minWidth: x.minWidth,
											fontSize: "0.875rem",
											maxWidth: x.maxWidth,
										}}
										headerStyle={{
											whiteSpace: whiteSpace ? whiteSpace : "nowrap",
										}}
										footer={x.field === 'shortExcess' ? shortExcessColumnFooter(x.footer) : formatThousandSeperatorWithTwoFixedAmount(x.footer)}
										body={(rowData: any, row: any) =>
											columnsBodyWithManagedBySimplePay(rowData, row, x)
										}
									/>
								);
							})}

					{rows && rows.length ? (
						<Column
							body={printPD7Body}
							header={"Print PD7"}
							// style={{
							// 	width: "36px",
							// }}
							resizeable={false}
							reorderable={false}
							frozen
							alignFrozen="right"
							// className="printPD7ColumnHeader"
							headerClassName="printPD7ColumnHeader"
						></Column>
					) : undefined}
				</DataTable>
			</>
		);
	};
